import { useContext, useEffect } from 'react';
import { useGetNosiasForAccount } from '@app/sdk';
import { AccountContext, useAccountContext } from '../../AccountContext';
import { Button } from 'semantic-ui-react';

export default function NosiaSelector() {
  const { accountId } = useContext(AccountContext);
  const { data: nosias } = useGetNosiasForAccount(accountId);
  const { setSelectedNosia, setNosiaJsonView } = useAccountContext();

  useEffect(() => {
    if (nosias?.value && nosias?.value?.length > 0) {
      setSelectedNosia(nosias.value[0]);
    }
  }, [nosias]);

  return (
    <>
      <div className="ui">
        {nosias?.value?.map((nosia, index) => (
          <Button
            key={
              nosia.firstBillingPeriod.billingPeriodId.toString() + nosia.lastBillingPeriod.billingPeriodId.toString()
            }
            style={{ marginBottom: '5px' }}
            icon="warning sign alternate"
            className="ui button"
            labelPosition="left"
            content={
              <div>
                NOSIA {index + 1}
                <div className="ui grey sub header">
                  Billing periods {nosia.firstBillingPeriod.billingPeriodId} & {nosia.lastBillingPeriod.billingPeriodId}
                </div>
              </div>
            }
            onClick={() => {
              setNosiaJsonView(false);

              return setSelectedNosia(nosias.value[index]);
            }}
          />
        ))}
        {nosias?.value?.length > 0 && (
          <Button
            key={'nosia-json-view'}
            style={{ marginBottom: '5px' }}
            icon="file alternate"
            className="ui button"
            labelPosition="left"
            content={
              <div>
                NOSIA Json view
                <div className="ui grey sub header">View all data</div>
              </div>
            }
            onClick={() => {
              return setNosiaJsonView(true);
            }}
          />
        )}
      </div>
    </>
  );
}
